<div (click)="toggle()" class="iconInformation">
  <div class="iconInformation__block">
    <div class="iconInformation__block__icon">
      <mat-icon *ngIf="!expanded" style="color:#FD7394">add_circle_outline</mat-icon>
      <mat-icon *ngIf="expanded" [ngStyle]="expandedStyles()">add_circle</mat-icon>
    </div>

    <div class="iconInformation__block__information">
      <div
        class="iconInformation__block__information__title"
        [innerHtml]="_title | safeHtml">
      </div>

      <div *ngIf="expanded"
           class="iconInformation__block__information__paragraph"
           (click)="onHtmlClick($event)">
        <div [innerHtml]="_paragraphs | safeHtml"></div>
      </div>
    </div>
  </div>

  <mat-divider class="iconInformation__divider"></mat-divider>
</div>
